var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconIndeterminate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.609 1H7.391C3.387 1 1 3.387 1 7.391V16.598C1 20.613 3.387 23 7.391 23H16.598C20.602 23 22.989 20.613 22.989 16.609V7.391C23 3.387 20.613 1 16.609 1ZM16.4 12.825H7.6C7.149 12.825 6.775 12.451 6.775 12C6.775 11.549 7.149 11.175 7.6 11.175H16.4C16.851 11.175 17.225 11.549 17.225 12C17.225 12.451 16.851 12.825 16.4 12.825Z",
    fill: "#253D87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconIndeterminate);
export default __webpack_public_path__ + "static/media/common_icon_indeterminate.0cc9fe65c276339a020efb2efab65af8.svg";
export { ForwardRef as ReactComponent };